import { Injectable, Inject } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";

let myAppUrl = "";
@Injectable({
  providedIn: "root",
})
export class AllocatePointsService {
  constructor(
    private _http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
  ) {
    myAppUrl = baseUrl;
  }

  sampleFileDownload(model) {
    window.open(
      myAppUrl + "api/AllocatePoints/SampleFileDownload?filename=" + model,
      "_blank",
    );
  }

  Import(data) {
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/Import", data)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  getAllocatePointsList(isAllocated, sortColumn = "CompanyName", sortOrder = "ASC", searchValue = "", recordCount = 25, pageNumber = 1) {
    let url = myAppUrl + "api/AllocatePoints/AllocatePointsList?isAllocated=" + isAllocated
      + "&sortColumn=" + encodeURIComponent(sortColumn)
      + "&sortOrder=" + encodeURIComponent(sortOrder)
      + "&recordCount=" + recordCount
      + "&pageNumber=" + pageNumber;
    if (searchValue) {
      url += "&searchValue=" + encodeURIComponent(searchValue);
    }
    return this._http.get<any>(url).pipe(
      map((data) => {
        return data;
      }),
    );
  }

  getPointAllocation(year: number, status: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetPointAllocation?year=" +
        year +
        "&status=" +
        status +
        "&isExport=true",
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  updateAllocationStatus(data) {
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/UpdateAllocationStatus", data)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  getCustomerWisePointsAllocation(enrollmentId: number, year: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetCustomerWisePointsAllocation?enrollmentId=" +
        enrollmentId +
        "&year=" +
        year,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  updateCustomerWiseAllocationStatus(data) {
    return this._http
      .post<any>(
        myAppUrl + "api/AllocatePoints/UpdateCustomerWiseAllocationStatus",
        data,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  savePointsAllocation() {
    return this._http
      .get<any>(myAppUrl + "api/AllocatePoints/SavePointsAllocation")
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  savePostTripPoints(data: any) {
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/SavePostTripPoints", data)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  saveCatalogPoints(data: any) {
    console.log("Service: Sending catalog points data to API:", data);
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/SaveCatalogPoints", data)
      .pipe(
        map((responseData) => {
          console.log(
            "Service: API response for saveCatalogPoints:",
            responseData,
          );
          return responseData;
        }),
        catchError((error) => {
          console.error("Service: Error in saveCatalogPoints:", error);
          throw error;
        }),
      );
  }
  saveRollOverPoints(data: any) {
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/SaveRollOverPoints", data)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getPointsOptionBreakUp(tripId: number, customerId: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetPointsOptionBreakUp?tripId=" +
        tripId +
        "&customerId=" +
        customerId,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  getCatalogPoint(years: number) {
    return this._http
      .get<any>(myAppUrl + "api/AllocatePoints/GetCatalogPoint?years=" + years)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  //Catalog points listing of customer
  getCatalogPointByCustomer(years: number, customerId: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetCatalogPointByCustomer/" +
        years +
        "/" +
        customerId,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  deleteCatalogPoint(id: number) {
    return this._http
      .get<any>(myAppUrl + "api/AllocatePoints/DeleteCatalogPoint?id=" + id)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  importCatalogPoints(data) {
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/ImportCatalogPoints", data)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  saveCatalogBuyPoints(data: any) {
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/SaveCatalogBuyPoints", data)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  deleteCatalogBuyPoints(id: number) {
    return this._http
      .post<any>(
        myAppUrl + "api/AllocatePoints/DeleteCatalogBuyPoints/" + id,
        null,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  deleteRollOverPoint(id: number, deletedBy: number) {
    return this._http
      .post<any>(
        myAppUrl +
        "api/AllocatePoints/DeleteRollOverPoint/" +
        id +
        "/" +
        deletedBy,
        null,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  //Added By Chandan
  //Catalog-purchased-points listing of customer
  getCatalogBuyPointByCustomer(years: number, customerId: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetCatalogBuyPointByCustomer/" +
        years +
        "/" +
        customerId,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getPostTripPointByCustomer(years: number, customerId: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetPostTripPointByCustomer/" +
        years +
        "/" +
        customerId,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getReAllocateEnabled(customerId: number) {
    return this._http
      .get<any>(
        myAppUrl + "api/AllocatePoints/GetReAllocateEnabled/" + customerId,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  reAllocateCustomerPoints(years: number, customerId: number, roleId:number) {
    return this._http
      .post<any>(
        myAppUrl +
        "api/AllocatePoints/ReAllocateCustomerPoints/" +
        years +
        "/" +
        customerId + "/" + roleId,
        null,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  getTripWhsDefaultDropdowns(years: number, ppeWhsCode:any) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetTripWhsDefaultDropdowns/" +
        years +
        "/" +
        ppeWhsCode,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getARStatusByCustomerIdAndYear(years: number, customerId: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetARStatusByCustomerIdAndYear/" +
        years +
        "/" +
        customerId,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getPendingArReleasedCount() {
    return this._http
      .get<any>(myAppUrl + "api/TripEnrollment/PendingArReleasedCount/")
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getotherCatalog() {
    return this._http
      .get<any>(myAppUrl + "api/AllocatePoints/GetOtherCatalogs")
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getReportCatalogPoint(years) {
    return this._http
      .get<any>(
        myAppUrl + "api/AllocatePoints/GetReportCatalogPoints?years=" + years,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getBillEstimate(customerId, years, availablePoints) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/GetBillEstimate?customerId=" +
        customerId +
        "&years=" +
        years +
        "&availablePoints=" +
        availablePoints,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  PostTripPointsOptionBreakUp(customerId: number, years: number) {
    return this._http
      .get<any>(
        myAppUrl +
        "api/AllocatePoints/PostTripPointsOptionBreakUp/" +
        customerId +
        "/" +
        years,
      )
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  getTripOptions() {
    return this._http
      .get<any>(myAppUrl + "api/AllocatePoints/getTripOptions")
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  getEligibleCustomersForSelectedTrips(tripIds: number[]) {
    return this._http
      .post<any>(
        myAppUrl + `api/AllocatePoints/GetCustomersForExactTrips`,
        tripIds  // ← pass tripIds as the POST body
      )
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  uploadFile(data) {
    return this._http.post<any>(myAppUrl + "api/Upload", data).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  importPointsAllocation(data) {
    return this._http
      .post<any>(myAppUrl + "api/AllocatePoints/ImportPointsAllocation", data)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }
  // saveImportedPointsAllocation(data: any, updatedBy: number) {
  //   return this._http
  //     .post<any>(myAppUrl + "api/AllocatePoints/SaveImportedPointsAllocation"+"?updatedBy=" + updatedBy, data)
  //     .pipe(
  //       map((data) => {
  //         return data;
  //       }),
  //     );
  // }
  saveImportedPointsAllocation(data: any, updatedBy: number) {
  return this._http.post<any>(
    `${myAppUrl}api/AllocatePoints/SaveImportedPointsAllocation?updatedBy=${updatedBy}`,
    data
  );
}

  getCachedAllocatePointsList(
    sortColumn = "CompanyName",
    sortOrder = "ASC",
    searchValue = "",
    recordCount = 25,
    pageNumber = 1
  ) {
    let url =
      myAppUrl +
      "api/PointsAllocationCache/GetCachedAllocatePointsList" +
      "?sortColumn=" + encodeURIComponent(sortColumn) +
      "&sortOrder=" + encodeURIComponent(sortOrder) +
      "&recordCount=" + recordCount +
      "&pageNumber=" + pageNumber;

    if (searchValue) {
      url += "&searchValue=" + encodeURIComponent(searchValue);
    }

    return this._http.get<any>(url).pipe(map((data) => data));
  }

  refreshPointsCache() {
    return this._http
      .post<any>(myAppUrl + "api/PointsAllocationCache/RefreshCache", null)
      .pipe(map((data) => data));
  }

  getLastCacheRefreshTime() {
    return this._http
      .get<any>(myAppUrl + "api/PointsAllocationCache/GetLastRefreshTime")
      .pipe(map((data) => data));
  }
}
